const NotFound = () => {
    return (
      <main style={{ textAlign: "center", padding: "4rem" }}>
        <h1>404</h1>
        <p>Página não encontrada 😢</p>
        
      </main>
    );
  };
  
  export default NotFound;